var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClicked = function SvgClicked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clicked_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(1562 564)",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".clicked_svg__d{fill:none;stroke:#babcff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.2px}"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1562 -564)",
    style: {
      clipPath: "url(#clicked_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2246.081 1254.814v12.986l3.781-5.225 6.12-.1Z",
    transform: "translate(-675.943 -684.318)",
    style: {
      stroke: "#babcff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2px",
      fill: "transparent"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "clicked_svg__d",
    d: "M1570.191 564.66v2.724M1566.141 566.338l1.926 1.926M1564.463 570.388h2.724M1566.141 574.439l1.926-1.926M1574.242 566.338l-1.926 1.926M1575.92 570.388h-2.724"
  }))));
};
export default SvgClicked;